/**
 * What view the user is currently viewing
 * (We night want to allow more viewing values than board or doc)
 */
export enum MemberViewing {
  BOARD = 'board',
  DOC = 'doc',
}
